// Calls back when the connection returns (FR-023): the window `online` event (see
// useNetworkStatus.web.ts for why not NetInfo on the web).
export function onOnline(listener: () => void): () => void {
  window.addEventListener("online", listener);
  return () => window.removeEventListener("online", listener);
}
